import { EnvConfig } from "../../types";

export const customerConfigLocal: EnvConfig = {
  MODULE_NAME: "customer",
  MODULE_ENV: "local",
  LD_CLIENT_SIDE_ID: "63583be10d275b11a1f32f7b",
  MANIFEST_URL: "http://localhost:4200/module-federation.manifest.json"
};
